// extracted by mini-css-extract-plugin
export var blockLeft = "s-module--blockLeft--50e7b";
export var blockRight = "s-module--blockRight--6bac2";
export var clickToCallLink = "s-module--clickToCallLink--ce8f6";
export var container = "s-module--container--593ff";
export var footer = "s-module--footer--fd496";
export var footerBackgroundBlock = "s-module--footerBackgroundBlock--3e58d";
export var footerBottom = "s-module--footerBottom--13d13";
export var footerBottomWrapper = "s-module--footerBottomWrapper--0e5e3";
export var footerChina = "s-module--footerChina--39b34";
export var footerCopyrights = "s-module--footerCopyrights--c0cec";
export var footerHeading = "s-module--footerHeading--2a49d";
export var footerListItem = "s-module--footerListItem--060a3";
export var footerLists = "s-module--footerLists--b093d";
export var footerLogo = "s-module--footerLogo--317f4";
export var footerLogoWrapper = "s-module--footerLogoWrapper--3863a";
export var footerMenu = "s-module--footerMenu--88257";
export var footerMenuWrapper = "s-module--footerMenuWrapper--c3ace";
export var footerNav = "s-module--footerNav--e7619";
export var footerPlain = "s-module--footerPlain--6d4dd";
export var footerPolicy = "s-module--footerPolicy--d2fa6";
export var footerSocial = "s-module--footerSocial--09e90";
export var footerTop = "s-module--footerTop--564b8";
export var footerTopWrapper = "s-module--footerTopWrapper--53bc8";
export var twitter = "s-module--twitter--2ba92";